export const viewOptions = [
  { value: 0, label: 'Expand All' },
  { value: 1, label: 'Collapse All' }
]

export const pfThatRequiresOptionsAutoMagically = [
  'navigateToNextStageBasedOnAgeRange', 'navigateToNextStageFromAnswer', 'navigateToNextStageFromScoreRank',
  'fetchValueBasedOnSelectedDemographic', 'navigateToNextStageBasedOnRandomSplit', 'navigateToNextStageBasedOnUsersLocation', 'navigateToNextStageBasedOnUsersLocationSubstring',
  'checkUserIsInANCOnboarding', 'navigateToNextStageBasedOnBookingStatus', 'checkUserHaveSpecificReferral', 'navigateToNextStageBasedOnInsurancePlan', 'checkIfResourceExistNearUserLocation',
  'navigateToNextStageBasedExistanceOfRecommendation', 'navigateBasedOnKeyword', 'validateDigitalVoucherCode'
]

export const demographicOptions = [
  { id: 0, label: 'gender', values: ['man', 'woman', 'nonbinary', 'default'] },
  { id: 1, label: 'language', values: ['hau', 'eng', 'swa', 'hi', 'asm', 'kan', 'mar', 'odi', 'tel', 'tha', 'default'] },
  { id: 2, label: 'country', values: ['India', 'Nigeria', 'Kenya', 'Thailand', 'India_MSD', 'Malaysia', 'Singapore', 'Indonesia', 'Philippines', 'Uganda', 'default'] },
  { id: 3, label: 'channel', values: ['whatsapp', 'messenger', 'web', 'sms', 'default'] },
  { id: 4, label: 'age group', values: ['below_15', '15_17', '18_26', '27_34', '35_44', '45_54', '55_64', 'above_65', 'default'] },
  { id: 5, label: 'anc journey user', values: ['anc_yes', 'anc_no', 'default'] },
  { id: 6, label: 'pnc journey user', values: ['pnc_yes', 'pnc_no', 'default'] }
]

export const bookingStatusOptions = [
  { id: 0, label: 'Successfully booked', value: 'BOOKED_SUCCESSFULLY' },
  { id: 1, label: 'No slots available', value: 'NO_SLOTS_AVAILABLE' },
  { id: 2, label: 'User cancelled booking', value: 'USER_CANCELLED' },
  {
    id: 3,
    label: 'User Slot Preference Missing',
    value: 'USER_SLOT_PREFERENCE_MISSING'
  },
  { id: 4, label: 'Error occurred in booking', value: 'API_ERROR' },
  {
    id: 5,
    label: 'default',
    value: 'default'
  }
]

export const digitalVoucherValidationOptions = ['valid', 'valid_but_already_redeemed', 'invalid']

export const locationOptions = [
  { name: 'Location From Onboarding', value: 'Location From Onboarding' },
  { name: 'Location From Referral', value: 'Location From Referral' }
]

export const referralAppOptions = [
  { value: 'PHYSICAL_LOADMORE_THEN_VIRTUAL', label: 'First Physical Resources then ask to Load more and then show virtual Resources (Traditional)' },
  { value: 'VIRTUAL_THEN_PHYSICAL_ASKFOR_LOADMORE', label: 'First Virtual Resources then show Physical Resources and ask to Load more Physical Resources' },
  { value: 'PHYSICAL_THEN_VIRTUAL', label: 'Physical Resources then Virtual Resources (Old)' },
  { value: 'PHYSICAL_ONLY', label: 'Physical Resources Only' },
  { value: 'VIRTUAL_ONLY', label: 'Virtual Resources Only' },
  { value: 'PHYSICAL_THEN_VIRTUAL_AFTER_INPUT', label: 'Physical Resources then ask for Input to show Virtual Resources' },
  { value: 'PHYSICAL_THEN_VIRTUAL_AFTER_INPUT_THEN_LOADMORE', label: 'Physical Resources then ask for Input to show virtual Resources. Ask again to show more Physical Resources' },
  { value: 'VIRTUAL_THEN_PHYSICAL_AFTER_INPUT_THEN_LOADMORE', label: 'Virtual Resources then ask for Input to show Physical Resources. If Physical resource input is yes then ask for input to show load more Physical Resources' },
  { value: 'PHYSICAL_THEN_VIRTUAL_ASKFOR_LOADMORE', label: 'First Physical Resources then virtual Resources then ask to Load more Physical Resources' }
]

export const specificReferralTypes = [
  { id: 'any_referral', label: 'Any referral', value: 'any_referral' },
  { id: 'both_referral', label: 'Both physical and virtual referral', value: 'both_referral' },
  { id: 'physical_referral', label: 'Physical referral', value: 'physical_referral' },
  { id: 'virtual_referral', label: 'Virtual referral', value: 'virtual_referral' },
  { id: 'virtual_referral_only', label: 'Virtual referral only', value: 'virtual_referral_only' },
  { id: 'physical_referral_only', label: 'Physical referral only', value: 'physical_referral_only' }
]

export const yesNoOptions = [
  { label: 'yes', value: 'yes' },
  { label: 'no', value: 'no' }
]

export const locationTypes = [
  { id: 'ONBOARD_LOCATION', label: 'Onboard location', value: 'Onboard Location' },
  { id: 'REFERRAL_LOCATION', label: 'Referral location', value: 'Referral Location' }
]

export const kmDistanceOptions = Array.from({ length: 20 }, (v, k) => ({
  id: k + 1,
  label: (k + 1).toString() + ' KM',
  value: k + 1
}))

export const insurancePlanOptions = [
  {
    label: 'platinum',
    value: 'platinum'
  },
  {
    label: 'gold',
    value: 'gold'
  },
  {
    label: 'silver',
    value: 'silver'
  },
  {
    label: 'default',
    value: 'default'
  }
]

export const tagTypes = [
  { label: 'Category', id: 'category' },
  { label: 'Binary', id: 'binary' },
  { label: 'Quiz', id: 'quiz' }
]



// WEBPACK FOOTER //
// ./src/components/shared/constant.js